/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { useLocation, useHistory, Link } from 'react-router-dom';
import './css/App.css';
import { useState, useEffect } from 'react'
import Logo from './logoaclitrasparentebianco.png'
import { getUserFromStorage, removeUserFromStorage } from './helper/handler';
import { getFromApi } from './utilities/NetUtilities';
import { buildUrl } from './helper/handler';
import { FaHome, FaSignOutAlt } from "react-icons/fa";

const Header = () => {

  const [userLogged, setUserLogged] = useState(null);
  const [showOrganizzazioni, setShowOrganizzazioni] = useState(false);
  const [showUtenti, setShowUtenti] = useState(false);
  const [showOrarioLavoro, setShowOrarioLavoro] = useState(false);
  const [showObiettivi, setShowObiettivi] = useState(false);
  const [showArea, setShowArea] = useState(false);
  const location = useLocation()
  const [headerCase, setHeaderCase] = useState("navbarDefault")
  const [orgLogged, setOrgLogged] = useState({ nome: "", tipo: "" })
  const history = useHistory();

  useEffect(() => {
    var organizationLogged = window.sessionStorage.getItem("organizzazione")
    if (organizationLogged) {
      setOrgLogged(JSON.parse(organizationLogged))
    }
    const getShow = (user) => {
      setUserLogged(user);
      if (user.role === 'AMMINISTRATORE' || user.role === 'SUPER_AMMINISTRATORE') {
        setShowUtenti(true);
        setShowOrarioLavoro(true);
        setShowOrganizzazioni(true);
        setShowObiettivi(true)
      }
      if (user.role === 'AMMINISTRATORE' || user.role === 'SUPER_AMMINISTRATORE' || user.role === 'AMMINISTRATORE_ORGANIZZAZIONE') {
        setShowArea(true)
      }
      const pathName = location.pathname
      const list = ["/", "/login", "/logout", "/landingpage",
        "/gestioneutenti", "/gestioneorganizzazioni", "/addorganizzazione", "/editorganizzazione",
        "/orariolavorolavoratore", "/orariolavorosede", "/orariolavorosettimana", "/reportorariolavoro"]
      if (!list.includes(pathName) || organizationLogged) {
        setHeaderCase("navbarAnalisi")
      }
      if (pathName === "/editorganizzazione" && organizationLogged) {
        setHeaderCase("navbarAnalisi")
      }
      if (pathName === "/resetpassword") {
        setHeaderCase("navbarEmpty")
      }
      if (pathName === "/landingpage") {
        setHeaderCase("navbarDefault")
      }
    }
    const user = getUserFromStorage();
    if (user) {
      getShow(user);
    }
  }, [location])

  const logOut = () => {
    removeUserFromStorage();
    window.sessionStorage.removeItem("username");
    window.sessionStorage.removeItem("password");
    const url = buildUrl("logout");
    getFromApi(url, null, null);
    history.push("/");
  }

  const switchHeader = () => {
    switch (headerCase) {
      case "navbarDefault":
        return (
          <div className="header">
            <Navbar expand="sm" data-testid="navbar">
              <Navbar.Brand to="/landingpage">
                <img src={Logo} height="80" alt="logo acli" />
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="basic-navbar-nav" className="menu" />
              {userLogged  && 
                <Navbar.Collapse id="basic-navbar-nav">
                <Nav className={`ml-auto`} variant="pills" >
                {showArea && <a id="home" href="/landingpage" className='home'><FaHome/></a>}
                  {showArea && <NavDropdown title="attività e gestione" id="logged-no-org" className='dropdown-menu-left'>
                    {showOrganizzazioni &&
                      <NavDropdown.Item id="gestione_organizzazioni" as={Link} to="/gestioneorganizzazioni">
                        gestione organizzazioni
                      </NavDropdown.Item >}
                    {showUtenti &&
                      <NavDropdown.Item id="gestione_utenti" as={Link} to="/gestioneutenti">gestione utenti
                      </NavDropdown.Item >}
                  </NavDropdown>}
                  <a id="logout" onClick={logOut} className='logout'><FaSignOutAlt/></a>
                </Nav>
              </Navbar.Collapse>}
            </Navbar>
          </div>
        )
      case "navbarAnalisi":
        return (
          <div className="header">
            <Navbar expand="lg" data-testid="navbar">
              <Navbar.Brand href="/landingpage" id="logo">
                <img src={Logo} height="80" alt="logo acli" />
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="basic-navbar-nav" className="menu" />
              {userLogged && <Navbar.Collapse id="basic-navbar-nav">
                <Nav className={`ml-auto`} variant="pills" >

                <a id="home" href="/landingpage" className='home'><FaHome/></a>

                  {showOrarioLavoro && <NavDropdown title="turni di lavoro" id="menu_turni" className='dropdown-menu-left'>
                    <NavDropdown.Item as={Link} id="orariolavorolavoratore" to="orariolavorolavoratore">gestione</NavDropdown.Item>
                    <NavDropdown.Item id="reportorario" as={Link} to="/reportorariolavoro">report</NavDropdown.Item>
                    <NavDropdown.Item id="sintesisettimana" as={Link} to="/sintesisettimana">sintesi settimana</NavDropdown.Item>
                    <NavDropdown.Item id="gestionote" as={Link} to="/gestionenote">note</NavDropdown.Item>
                  </NavDropdown>}

                  {showOrarioLavoro && <NavDropdown title="ferie/permessi" id="menu_ferie" className='dropdown-menu-left'>
                    <NavDropdown.Item as={Link} id="gestioneferiepermessi" to="/gestioneferiepermessi">gestione</NavDropdown.Item>
                    <NavDropdown.Item as={Link} id="pianoferie" to="/pianoferie">piano ferie</NavDropdown.Item>
                  </NavDropdown>}
                  <NavDropdown title="analisi" id="menu_analisi" className='dropdown-menu-left'>
                    <NavDropdown.Item id="riepilogo_generale" as={Link}
                      to="/riepilogogenerale">riepilogo generale</NavDropdown.Item>
                    <NavDropdown.Item id="obiettivi730" to="/obiettivi730" as={Link}>
                        obiettivi 730
                    </NavDropdown.Item>
                    <NavDropdown title="Aree" drop={"left"} className='submenu' id="aree">
                      <NavDropdown.Item id="area730" to="/area730" as={Link}>730</NavDropdown.Item>
                      <NavDropdown.Item id="areaImu" to="/areaimu" as={Link}>imu</NavDropdown.Item>
                      <NavDropdown.Item id="areaUnico" to="/areaunico" as={Link}>unico</NavDropdown.Item>
                      <NavDropdown.Item id="areaCondomini" to="/areacondomini" as={Link}>condomini</NavDropdown.Item>
                      <NavDropdown.Item id="areaSuccessioni" to="/areasuccessioni" as={Link}>successioni</NavDropdown.Item>
                      <NavDropdown.Item id="areaLocazioni" to="/arealocazioni" as={Link}>locazioni</NavDropdown.Item>
                      <NavDropdown.Item id="areaVarie" to="/areavarie" as={Link}>varie</NavDropdown.Item>
                    </NavDropdown>
                    <NavDropdown title="Campagna 730" drop={"left"} className='submenu' id="campagna730">
                      <NavDropdown.Item id="fatturatoSettimanale730" to="/fatturatosettimanale730" as={Link}>
                        fatturato settimanale 730
                      </NavDropdown.Item>
                      <NavDropdown.Item id="fatturatoCumulativo730" to="/fatturatocumulativo730" as={Link}>
                        fatturato cumulativo 730
                      </NavDropdown.Item>
                      <NavDropdown.Item id="numeroSettimanale730" to="/numerosettimanale730" as={Link}>
                        numero settimanale 730
                      </NavDropdown.Item>
                      <NavDropdown.Item id="numeroCumulativo730" to="/numerocumulativo730" as={Link}>
                        numero cumulativo 730
                      </NavDropdown.Item>
                      <NavDropdown.Item id="numeroSettimanale730InModifica" to="/numerosettimanale730inmodifica" as={Link}>
                        numero settimanale 730 in modifica
                      </NavDropdown.Item>
                      <NavDropdown.Item id="riepiloghi" to="/riepiloghi" as={Link}>
                        riepiloghi
                      </NavDropdown.Item>
                      <NavDropdown.Item id="riepilogoTotale" to="/riepilogototale" as={Link}>
                        riepilogo totale
                      </NavDropdown.Item>
                      <NavDropdown.Item id="produzionePerSede" to="/produzionepersede" as={Link}>
                        produzione per sede
                      </NavDropdown.Item>
                    </NavDropdown>
                    <NavDropdown title="Campagna Isee" drop={"left"} className='submenu' id="campagnaIsee">
                      <NavDropdown.Item id="numeroSettimanaleIsee" to="/numerosettimanaleisee" as={Link}>
                        numero settimanale ISEE
                      </NavDropdown.Item>
                      <NavDropdown.Item id="numeroCumulativoIsee" to="/numerocumulativoisee" as={Link}>
                        numero cumulativo ISEE
                      </NavDropdown.Item>
                      <NavDropdown.Item id="numeroSettimanaleIseeInModifica" to="/numerosettimanaleiseeinmodifica" as={Link}>
                        numero settimanale ISEE in modifica
                      </NavDropdown.Item>
                      <NavDropdown.Item id="riepiloghiIsee" to="/riepiloghiisee" as={Link}>
                        riepiloghi ISEE
                      </NavDropdown.Item>
                    </NavDropdown>
                  </NavDropdown>

                  <NavDropdown title="attività e gestione" id="logged" className='dropdown-menu-left'>
                    <NavDropdown.Item id="importa_dati" to="/caricafile" as={Link}>
                      importa dati
                    </NavDropdown.Item>
                    <NavDropdown.Item id="dati_per_sede" to="/datipersede" as={Link}>
                      dati per zona
                    </NavDropdown.Item>
                    {showObiettivi &&
                      <NavDropdown.Item id="obiettivo" to="/obiettivo" as={Link} >
                        obiettivi
                      </NavDropdown.Item>}
                    {showArea &&
                      <NavDropdown title="gestione organizzazione" id="menu_organizzazione"
                        drop={"left"} className='submenu'>
                        <NavDropdown.Item as={Link} id="zone_applicativi"
                          to={{ pathname: `/editorganizzazione`, search: `nome=${orgLogged.nome}&tipo=${orgLogged.tipo}` }}>
                          zone / applicativi</NavDropdown.Item>
                        <NavDropdown.Item id="associazione_area" as={Link}
                          to="/associazionearea">associazione area
                        </NavDropdown.Item>
                      </NavDropdown>
                    }
                    {showOrarioLavoro &&
                      <NavDropdown title="gestione turni lavoro" id="menu_orariolavoro"
                        drop={"left"} className='submenu'>
                        <NavDropdown.Item id="gestionelavoratori" as={Link} to="/gestionelavoratori">gestione lavoratori</NavDropdown.Item>
                        <NavDropdown.Item id="gestionesedi" as={Link} to="/gestionesedi">gestione sedi</NavDropdown.Item>
                        <NavDropdown.Item id="gestioneservizi" as={Link} to="/gestioneservizi">gestione servizi</NavDropdown.Item>
                        <NavDropdown.Item as={Link} id="gestione_email_frequenti" to="/gestionemailfrequenti">gestione email frequenti</NavDropdown.Item>
                      </NavDropdown>}
                    {showUtenti &&
                      <NavDropdown.Item id="gestione_utenti" as={Link} to="/gestioneutenti">gestione utenti
                      </NavDropdown.Item >}
                  </NavDropdown>
                  <a id="logout" onClick={logOut} className='logout'><FaSignOutAlt/></a>
                </Nav>
              </Navbar.Collapse>}
            </Navbar>
          </div>
        )
      case "navbarEmpty":
        return (
          <div className="header">
            <Navbar expand="lg" data-testid="navbar">
              <Navbar.Brand href="/" id="logo">
                <img src={Logo} height="80" alt="logo acli" />
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="basic-navbar-nav" className="menu" />
            </Navbar>
          </div>
        )
      default:
        break
    }
  }

  return switchHeader();

}

export default Header;